{
    "Tickets": "Tickets",
    "Ticket wählen": "Choose ticket",
    "Tickets auswählen": "Choose Tickets",
    "Tickets ausgewählt": "selected",
    "Alle Arten": "All kind",
    "Ticketarten": "Ticket types",
    "für": "for",
    "Ja": "Yes",
    "Nein": "No",
    "Checkout": "Checkout",
    "Nicht mehr verfügbar": "No more available",
    "Noch nicht verfügbar": "Not yet available",
    "Required": "Required",
    "Empfänger bestimmen": "set recipient",
    "Zusammenfassung": "Summary",
    "Persönliche Daten": "Personal Data",
    "Zahlungsart auswählen": "Choose the method of payment",
    "Die Zahlungsarten erscheinen, sobald ein Land ausgewählt ist.": "Payment methods appear once a country is selected.",
    "Für das gewählte Land ist keine Zahlungsart verfügbar.": "No payment method is available for the selected country.",
    "Weiter": "Next",
    "Zurück": "Back",
    "Vorkasse": "Prepayment",
    "Vorname": "First name",
    "Nachname": "Last name",
    "Straße und Hausnummer": "Street and house number",
    "Firma": "Company",
    "USt-Id": "VAT-ID",
    "PLZ": "ZIP",
    "Ort": "City",
    "Email": "E-Mail",
    "E-Mail": "Email",
    "Land": "Country",
    "Empfänger": "Recipient",
    "Anzahl": "Number",
    "Art": "Kind",
    "Enthaltene MwSt.": "Complete VAT.",
    "Preis": "Price",
    "Zahlungsweise": "method of payment",
    "Gesamt": "Total",
    "Total": "Total",
    "Jetzt kaufen": "Buy now",
    "Jetzt kostenlos bestellen": "Order now for free",
    "Einkaufsliste": "Order Summary",
    "Dies ist keine E-Mail-Adresse!": "This is not an E-Mail-Address!",
    "Nichts gefunden": "Nothing found",
    "Personalisieren": "Personalize",
    "Personalisierung": "Personalization",
    "Personalisiere die Tickets": "Personalize the tickets",
    "Rechnungsdaten": "Billing Details",
    "Ich habe die": "I have read and accepted the",
    "AGB": "the terms and conditions.",
    "gelesen und akzeptiert.": "",
    "Datenschutzerklärung": "Data protection.",
    "Vielen Dank für Deine Bestellung. Du solltest in kürze eine Bestätigungsmail von uns erhalten. Bitte schau auch im SPAM Ordner nach.": "Thank you for your order. You should receive a confirmation email from us shortly. Please also check the spam folder.",
    "Entschuldigung, es gab einen Fehler bei der Übermittlung:": "Sorry, there was a submission error:",
    "Entschuldigung, der Server meldet einen Fehler. Bitte versuche es später noch einmal.": "Sorry, the server reports an error. Please try again later.",
    "Bitte versuche es später noch einmal.": "Please try again later.",
    "Teilnehmerdaten": "Participant details",
    "Entschuldigung. Die Anzahl der gewünschten Tickets ist derzeit nicht verfügbar.": "Sorry. The number of tickets requested is currently not available.",
    "Beim Abschluss der Bestellung ist ein Fehler aufgetreten:": "An error occurred while completing the order:",
    "Bitte überprüfe die AGBs": "Please subject to our general terms and privacy policy",
    "Geimpft/Genesen": "Vaccinated/recovered",
    "Weder Geimpft noch Genesen": "Neither vaccinated nor recovered",
    "Keine Angabe": "Not specified",
    "Weitere Angaben": "Other information",
    "Ticket entfernen": "Remove ticket",
    "Ticket entfernen?": "Do you really want to remove the ticket?",
    "Wir haben Ihre Eingaben gespeichert, möchten Sie diese verwenden?": "We have saved your entries, do you want to use them?",
    "Keine gültige E-Mail-Adresse": "No valid email-Address",
    "Tage": "Days",
    "Mi": "Wed",
    "Do": "Thu",
    "Fr": "Fri",
    "Sa": "Sat",
    "So": "Sun",
    "Mo": "Mon",
    "Karteninhaber": "Cardholder name",
    "Kreditkartennummer": "Credit card numbr",
    "Verfallsdatum": "Expiry date",
    "Bezahlen": "Pay",
    "Zahlung gesichert und bereitgestellt von": "Payment secured and powered by",
    "OpenPaymentBeforeUnload" : "Are you sure you want to close this tab? You order will be completely lost.",
    "Der eingegebene Gutschein-Code ist nicht gültig." : "The entered coupon code is not valid.",
    "Der eingegebene Gutschein-Code erfordert ein anderes Produkt." : "The entered coupon code requires a different product.",
    "Ich habe einen Gutschein-Code" : "I have a coupon code",
    "Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert." : "No payment method was defined in project settings!",
    "Gutschein-Code" : "Coupon / code",
    "Coupon-Code nicht gefunden oder nicht mehr gültig." : "Coupon / code not found or no longer valid.",
    "Code wurde gefunden!": "Code was found!",
    "Der Rabatt wird vor Kaufabschluss angezeigt.": "The discount will be shown during checkout.",
    "Es werden zusätzliche Produkte angezeigt.": "Additional products are displayed.",
    "Die Prüfung des Gutscheins erfolgt im nächsten Schritt" : "The coupon will be checked in the next step",
    "Ich möchte einen Betrag spenden" : "I want to make a donation",
    "Welcher Betrag soll gespendet werden?" : "What amount do you want to donate?",
    "Wir freuen uns über eine freiwillige Spende." : "We appreciate your voluntary donation.",
    "Anderer Betrag" : "Other amount",
    "Andere" : "Other",
    "Spende" : "Donation",
    "Gutschein" : "Coupon",
    "Gutschein gilt nur für bestimmte Produkte" : "Coupon affects only certain products",
    "Falls Du einen Coupon / Code hast, kannst Du diesen hier eingeben": "If you have a coupon / code, you can enter it here",
    "Jetzt prüfen" : "Check now",
    "Lädt.." : "Loading..",
    "Oh nein! Ein Fehler trat auf" : "Something went wrong.",
    "Leider gab es Probleme bei der Verarbeitung der Bestellung. Bitte versuche es später nochmal." : "Unfortunately there was a problem while processing your order. Please try again later.",
    "Dieser Shop wurde nicht gefunden." : "This shop was not found.",
    "Dieser Shop ist zurzeit nicht aktiv." : "This shop is currently not active.",
    "Fehler" : "Error",
    "Aktuell gibt es keine Produkte in diesem Shop." : "There are currently no products in this shop.",
    "Bestellung bezahlt" : "Order is paid",
    "Bestellung nicht gefunden" : "Order status",
    "Leider konnten wir Deine Bestellung nicht finden." : "Thank you for your order! For technical reasons we currently cannot determine the status of your order. You should receive a confirmation email from us shortly.",
    "Bestellung eingegangen" : "Order received",
    "Die Bestellung ist bei uns eingegangen. Du solltest in Kürze eine E-Mail von uns mit Zahlungsinformationen erhalten." : "We have received your order. You will soon get an e-mail from us with payment information.",
    "Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstmöglich bei Dir per E-Mail." : "Your payment was successful. Thank you! We will get in touch with you by e-mail.",
    "Bestellung abgebrochen": "Order cancelled",
    "Leider wurde Deine Bestellung abgebrochen. Versuche es gern später nochmal." : "Unfortunately your order was cancelled. Please try again later.",
    "Status Deiner Bestellung" : "Your order is currently in state",
    "Direktverkauf" : "Direct-Sale",
    "Vor-Ort Ticketshop" : "On-Site Ticket Shop",
    "Eingeloggt als:" : "Logged in as:",
    "Ausloggen" : "Log out",
    "Mehr erfahren" : "Read more",
    "Coupon-Tickets" : "Coupon Tickets",
    "Alle Tickets anzeigen" : "Show all tickets",
    "Bitte auswählen": "Please choose",
    "Ticket direkt an Käufer:In schicken": "Send ticket directly to client",
    "CheckPopup": "Please enable in your browser that the Mollie payment window can be opened as a pop-up. Try disabling pop-up blockers or similir tools.",
    "Wir haben gemerkt, dass Du schon mal Eingaben vorgenommen hast, möchtest Du diese verwenden?": "We noticed that you have already entered information. Would you like to use it?",
    "Cookie-Einstellungen" : "Cookie settings",
    "Reduzierte Produkte sind hervorgehoben.": "Reduced items are highlighted.",
    "Beinhaltet": "Contains",
    "Ich möchte auf dem Laufenden bleiben": "I want to stay up to date",
    "PDF drucken über": "Print PDF via",
    "Label drucken über": "Print label via",
    "Download (in neuem Tab öffnen)": "Download (open in new tab)",
    "PDF drucken": "Print PDF",
    "Label drucken": "Print label",
    "PDF herunterladen": "Download PDF",
    "Label herunterladen": "Download label",
    "… wird gedruckt": "… printing",
    "✓ gedruckt": "✓ printed",
    "Fehler — bitte erneut versuchen": "Error — please try again",
    "Einen Coupon / Code hier eingeben": "Enter a coupon / code here",
    "Vielen Dank für die Bestellung!": "Thank you for your order!",
    "In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.": "You should receive a confirmation email shortly. Please also check your spam folder.",
    "Vielen Dank für die Bestellung! In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.": "Thank you for your order! You should receive a confirmation email shortly. Please also check your spam folder.",
    "Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?": "We found previously entered data. Would you like to use it?",
    "Zahlungsart": "Payment method",
    "Terminal auswählen": "Select terminal",
    "Bestellung in Abwicklung": "Order in progress",
    "Bestellnummer": "Order number",
    "Warte auf Zahlung": "Waiting for payment",
    "Bestellung wird verarbeitet": "Processing order",
    "Bitte Karte am Terminal halten. Diese Seite aktualisiert sich automatisch.": "Please hold the card to the terminal. This page will update automatically.",
    "Die Bestellung wird gerade verarbeitet, bitte einen Moment warten.": "The order is being processed, please wait a moment.",
    "Test-Bezahlung im Mollie-Dashboard öffnen": "Open test payment in the Mollie dashboard",
    "Bestellung abbrechen": "Cancel order",
    "Bestellung erfolgreich": "Order successful",
    "Rechnung herunterladen": "Download invoice",
    "Cashless-Zahlung — der Beleg kommt vom Terminal des Cashless-Anbieters. festiware erstellt für diesen Verkauf keinen eigenen Kassenbeleg.": "Cashless payment — the receipt is issued by the cashless provider's terminal. festiware does not create its own receipt for this sale.",
    "TSE aktuell offline": "TSE currently offline",
    "Verkauf erfasst und Ticket gültig — die Fiskaly-Signatur wird automatisch nachgeholt, sobald die TSE wieder erreichbar ist. Bitte das Problem zeitnah von der Administration beheben lassen (§146a AO).": "Sale recorded and ticket valid — the Fiskaly signature will be added automatically as soon as the TSE is reachable again. Please have the administration fix the issue promptly (§146a AO).",
    "Tickets drucken": "Print tickets",
    "Es wurden keine Ticket-PDFs erzeugt.": "No ticket PDFs were generated.",
    "Ticket": "Ticket",
    "Neue Bestellung": "New order",
    "Test-Zahlung Mollie": "Mollie test payment",
    "Pop-up wurde blockiert. Bitte den folgenden Link öffnen:": "Pop-up was blocked. Please open the following link:",
    "Alternativ im Mollie-Dashboard unter \"Umsatz\" die offene Zahlung manuell auf bezahlt setzen.": "Alternatively, manually mark the open payment as paid in the Mollie dashboard under \"Transactions\".",
    "Schließen": "Close",
    "Produkte durchsuchen": "Search products",
    "Keine Produkte gefunden": "No products found",
    "Suche zurücksetzen": "Clear search",
    "Suche schließen": "Close search",
    "Produkt": "product",
    "Produkte": "products"
}
